import {
  drivingLesson,
  drivingLessonStatus,
  statusColors,
} from "../../utils/config";

export default function AgendaEvent({ event, categoryList }) {
  const isBooked = !!event.student_id;
  const typeColor = drivingLesson[event.lesson_type]?.color || "#81C784";
  const category =
    categoryList.find((c) => Number(c.id) === Number(event.category_id)) || {};

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "10px 0",
        width: "100%",
        gap: "15px",
      }}>
      <div
        style={{
          width: "4px",
          height: "40px",
          backgroundColor: typeColor,
          borderRadius: "2px",
        }}
      />
      <div style={{ flex: 1 }}>
        <h6 style={{ margin: 0, fontWeight: "600", color: "#333" }}>
          {isBooked ? event.student_name : "Свободный слот"}
        </h6>
        <p style={{ margin: 0, opacity: 0.7, color: "#000" }}>
          {category.name} • {drivingLesson[event.lesson_type]?.title}
        </p>
      </div>
      <div style={{ textAlign: "right" }}>
        <h6 style={{ margin: 0, color: "#333" }}>{event.teacher_name}</h6>
        <p
          style={{
            margin: 0,
            color: statusColors[event.lesson_status] || "#000",
            fontWeight: "700",
            fontSize: "0.8rem",
            textTransform: "uppercase",
          }}>
          {drivingLessonStatus[event.lesson_status]?.title}
        </p>
      </div>
    </div>
  );
}
